let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("l88uw")).then(() => parcelRequire('8pPPY'));